const PREFIX = 'cash_loan_';

export default {
  // flag : first_open / on_countdown
  trackCashLoanVisit({ currentScreen }) {
    const payload = {
      env: `${PREFIX}visit`,
      journey_id: this.getTrackerJourneyId,
      referrer_screen: this.routeReferrer?.name || '',
      referrer_url: this.routeReferrer?.url || '',
      current_screen: currentScreen,
    };
    this.$blTracker.actions.trackActions(payload);
  },
  trackCashLoanClick({ currentScreen, targetScreen, clickSource, clickSourceStatus }) {
    const payload = {
      env: `${PREFIX}click`,
      journey_id: this.getTrackerJourneyId,
      current_screen: currentScreen,
      target_screen: targetScreen,
      click_source: clickSource,
      click_source_status: clickSourceStatus || 'success',
    };
    this.$blTracker.actions.trackActions(payload);
  },
};
